/* GLITER steps (snippets/gliter-kroki-warianty.liquid): the step icons play once, one after another, when the steps come into view
   (his 3 Nov: „ikonki przy krokach animuj”). */
(() => {
  function init() {
    const lists = document.querySelectorAll('[data-glk] ol');
    if (!('IntersectionObserver' in window)) {
      lists.forEach((l) => l.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }),
      { threshold: 0.4 }
    );
    lists.forEach((l) => io.observe(l));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
